import CheckboxList from "./checkbox-list";

export default CheckboxList;
